import React from "react";

import Footer from "../../../components/common/Footer";
import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";

import { Card, Col, List, Row } from "antd";

const listItems = [
  "President",
  "Accountant",
  "Property Manager",
  "On-Site Manager",
  "Leasing Agent",
  "Accounts Payable",
  "Accounts Receivable",
  "View Only",
  "Maintenance Coordinator",
  "Maintenance Tech",
  "Regional Manager",
  "Assistant Property Manager",
  "Assistant Leasing Agent",
];

const GlAccountPermissionsRightBar = [];

function GlAccountPermissions() {
  return (
    <>
      <div className="page-container">
        <div className="main-container">
          <PageHeading heading="Manage GL Account Permissions" />
          <Row>
            <Col span={24}>
              <Card>
                <List
                  header={<h4>Roles</h4>}
                  dataSource={listItems}
                  renderItem={(item) => (
                    <List.Item>
                      {item}
                    </List.Item>
                  )}
                />
              </Card>
            </Col>
          </Row>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={GlAccountPermissionsRightBar} />
      </div>
    </>
  );
}

export default GlAccountPermissions;
